var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.reflect.get-own-metadata-keys.js
 ** module id = 217
 ** module chunks = 1
 **/